import { render, staticRenderFns } from "./AttributeShortcuts.vue?vue&type=template&id=148a6b61"
import script from "./AttributeShortcuts.vue?vue&type=script&lang=ts"
export * from "./AttributeShortcuts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports